import { notification } from '@ankr.com/raas-ui';
import { tCommon } from '@ankr.com/raas-utils';

import { isAxiosAuthError } from './isAxiosAuthError';

export interface HandlePermanentTokenErrorParams {
  error: unknown;
}

export const handlePermanentTokenError = ({
  error,
}: HandlePermanentTokenErrorParams) => {
  const message = isAxiosAuthError(error)
    ? tCommon('error.auth-token-expired')
    : tCommon('error.auth-unknown');

  notification({
    title: tCommon('error.error'),
    message,
    type: 'error',
  });
};
